<template>
<div class="col-12 py-md-5 py-3">
  <div class="txt-mobile text-center d-block d-md-none d-lg-none">Desliza hacia los lados y presiona para voltear <img src="@/assets/mano_desliza.png" class="img-desliza"></div>
  <vue-slick-carousel v-if="data.length > 0" ref="carousel" v-bind="settings">
    <div v-for="(item, index) in data" :key="index" class="px-2">
      <div class="box-card">
        <div v-if="item" class="card">
          <div class="front">
            <img :src="require(`@/assets/atletas/${item.img}.jpg`)" class="w-100">
            <div :class="item.lesionado === true ? 'front__background--lesionado' : 'front__background'">
              <div class="content_info-card">
                <span class="conten_info-nombre">{{ item.Deportista }}</span>
                <span class="conten_info-deporte">{{ item.Disciplina }}</span>
              </div>
              <img :src="require(`@/assets/disciplinas/${item.icono}.png`)" class="icono_deporte">
            </div>
          </div>
          <div class="back">
            <p>{{ item.Deportista }}</p>
            <ul>
              <li><b>Origen:</b> {{ item.Proveniencia }}</li>
              <li><b>Edad:</b> {{ item.Edad }} </li>
            </ul>
            <div class="resena"><span>Reseña</span><br>{{ item.Descripcion }}<br><br><img :src="require(`@/assets/instagram_card.png`)" class="redes_sociales-card"> @{{ item.ig }}</div>
          </div>
        </div>
      </div>
    </div>
  </vue-slick-carousel>
</div>
</template>
<script>
import axios from 'axios'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  components: { VueSlickCarousel },
  data() {
    return {
      data: [],
      settings: {
        arrows: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    }
  },
methods: {
  async getCardDescription () {
    try {
      const result =  await axios.get('https://webmr.cl/api-jjoo/api/fichas')
      if(result.data) {
        this.data = result.data
      }
    } catch (error) { console.log(error) }
    }
  },
  mounted () {
    this.getCardDescription()
  }
}
</script>